import { FC, PropsWithChildren, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useRouter } from 'next/router';

import GradientBanner from '@/Molecules/GradientBanner/GradientBanner';

import messages from './messages';

import useStyles from './styles';

const B2BBanner: FC<PropsWithChildren<unknown>> = () => {
  const { classes } = useStyles();
  const { query, replace } = useRouter();
  const [isBannerOpen, setIsBannerOpen] = useState(true);

  const isOxford = query.isOxford === 'true';
  const isHachette = query.isHachette === 'true';
  const isVuibert = query.isVuibert === 'true';
  const isMaman = query.isMaman === 'true';

  const allBannersType = new Map([
    [isOxford, 'Oxford'],
    [isHachette, 'Hachette'],
    [isVuibert, 'Vuibert'],
    [isMaman, 'Maman'],
  ]);

  const handleCloseBanner = () => {
    setIsBannerOpen(false);
    const { origin, pathname } = new URL(window.location.href);
    replace(`${origin}${pathname}`, undefined, {
      scroll: false,
      shallow: true,
    });
  };

  return (
    <>
      {(isOxford || isHachette || isVuibert || isMaman) && isBannerOpen && (
        <GradientBanner
          onClose={handleCloseBanner}
          className={classes.B2BBanner}
        >
          <FormattedMessage
            {...messages.title}
            values={{
              bannerType: allBannersType.get(true),
            }}
          />
        </GradientBanner>
      )}
    </>
  );
};

export default B2BBanner;
